module.exports = __webpack_public_path__ + "static/media/photo5.e353ecfa.png";